module.exports = __webpack_public_path__ + "90180335b6138feb77057607b893eb25.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/用户协议.pdf
// module id = 7AJJ
// module chunks = 1